export default __webpack_public_path__ + "static/media/landing.db70b839.jpg";